import { useMemo } from "react";
import { useSeo } from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestNews from "@/pages/home/components/LatestNews";
import TopicSection from "@/pages/home/components/TopicSection";
import AboutIntro from "@/pages/home/components/AboutIntro";

export default function Home() {
  useSeo({
    title: "黑人-权威黑人文化资讯平台-深度解读与最新动态",
    description:
      "黑人网站专注于提供丰富的黑人文化资讯、历史背景和社会动态，涵盖影视、音乐、艺术等多个领域，为用户带来全面的黑人文化内容和深度分析。",
    keywords: "黑人,黑人文化,黑人历史,黑人音乐,黑人艺术,黑人资讯,黑人社会动态",
  });

  const featured = useMemo(() => articles.filter((item) => item.featured), []);

  return (
    <>
      <HeroCarousel items={featured} />
      <CategoryGrid />
      <LatestNews />
      <TopicSection />
      <AboutIntro />
    </>
  );
}